import styled, { css, keyframes } from 'styled-components';

// One shimmer for every loading placeholder in the app, so they all move in step.
export const shimmer = keyframes`
  0% {
    background-position: 100% 0;
  }

  100% {
    background-position: -100% 0;
  }
`;

type ShimmerTones = {
  /** The resting colour of the placeholder. */
  base: string;
  /** The highlight that sweeps across it. */
  highlight: string;
};

/**
 * The shimmering background shared by the app's skeletons. Consumers own their own shape (size,
 * radius, element) and pick tones that sit on their container: the semantic neutrals on the
 * light leads table, the tracker's own greys inside the dark training-plans section.
 */
export const shimmering = ({ base, highlight }: ShimmerTones) => css`
  background: linear-gradient(90deg, ${base} 25%, ${highlight} 37%, ${base} 63%);
  background-size: 400% 100%;
  animation: ${shimmer} 1.4s ease-in-out infinite;
`;

/** A shimmering block in the semantic neutrals; extend it for a specific shape or pass `$tones`. */
const Skeleton = styled.div<{ $tones?: ShimmerTones }>`
  ${({ theme, $tones }) =>
    shimmering($tones ?? { base: theme.semantic.neutrals_300, highlight: theme.semantic.neutrals_400 })}
`;

export default Skeleton;
